/* ==========================================================================
   MI MARKET CI — moteur de recommandation « Pour vous »

   Ce fichier fait deux choses.

   1. Il OBSERVE. Sur chaque page il note ce que fait le visiteur : quelles
      fiches il ouvre, combien de temps il y reste, combien de fois il y
      revient, quels rayons il parcourt, ce qu'il cherche, ce qu'il met au
      panier, et par quelle porte il est entré (lien promo, recherche
      Google, réseaux). Tout reste dans le navigateur du visiteur, dans
      localStorage. Rien ne part vers un serveur tiers, aucune donnée
      personnelle n'est stockée : uniquement des identifiants de produits
      et des compteurs.

   2. Il DÉCIDE. Sur la page d'accueil, il croise ces signaux avec le
      catalogue rendu par Liquid et avec les recommandations de Shopify
      (qui, elles, viennent des commandes réelles de la boutique), puis
      classe les produits et remplit l'onglet « Pour vous ».

   Principe de prudence : si quoi que ce soit échoue — localStorage
   indisponible en navigation privée, réseau coupé, JSON cassé — la grille
   rendue par Liquid reste affichée telle quelle. Le moteur ne peut pas
   vider la page, seulement l'améliorer.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'mi_reco_v2';
  var DAY = 86400000;
  var MAX_VIEWS = 150;          /* au-delà on oublie les plus anciennes */
  var SESSION_GAP = 1800000;    /* 30 min d'inactivité = nouvelle visite */

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CFG = (window.MI && window.MI.reco) || {};

  /* ---------------------------------------------------------------- outils */

  function now() { return Date.now(); }

  function vide() {
    return {
      v: 2,
      views: {},     /* id produit -> { n, t, dwell, p, ty, vd, co } */
      cols: {},      /* handle collection -> poids */
      types: {},     /* type produit -> poids */
      vendors: {},   /* marque -> poids */
      q: [],         /* dernières recherches */
      cart: { n: 0, t: 0, ids: [] },
      src: {},       /* provenance : utm, référent */
      reasons: {},   /* raison -> { i: impressions, c: clics } */
      sess: { s: 0, last: 0, n: 0 }
    };
  }

  function lire() {
    try {
      var brut = localStorage.getItem(KEY);
      if (!brut) return vide();
      var d = JSON.parse(brut);
      if (!d || d.v !== 2) return vide();
      /* on complète les champs manquants plutôt que de tout jeter */
      var base = vide(), k;
      for (k in base) { if (!(k in d)) d[k] = base[k]; }
      return d;
    } catch (e) { return vide(); }
  }

  function ecrire(d) {
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }

  /* Un signal vieux de 30 jours ne vaut plus rien, un signal d'il y a une
     heure vaut presque tout. Demi-vie à 7 jours. */
  function fraicheur(t) {
    if (!t) return 0;
    var j = (now() - t) / DAY;
    if (j < 0) j = 0;
    return Math.pow(0.5, j / 7);
  }

  function bump(obj, cle, poids) {
    if (!cle) return;
    obj[cle] = (obj[cle] || 0) + poids;
  }

  function normalise(obj) {
    var max = 0, k;
    for (k in obj) { if (obj[k] > max) max = obj[k]; }
    if (!max) return {};
    var out = {};
    for (k in obj) { out[k] = obj[k] / max; }
    return out;
  }

  /* La ligne de raison ne fait qu'une ligne dans la carte. Un nom de
     produit complet la ferait deborder et finir en points de suspension,
     ce qui donne l'air casse. On raccourcit donc nous-memes, proprement. */
  function court(t, n) {
    t = String(t || '').trim();
    n = n || 20;
    if (t.length <= n) return t;
    return t.slice(0, n - 1).trim() + '…';
  }

  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    var txt = n.toLocaleString('en-US');
    var f = (window.MI && window.MI.money) || '{{amount}} FCFA';
    f = String(f).replace(/<[^>]*>/g, '');
    if (/\{\{/.test(f)) return f.replace(/\{\{[^}]*\}\}/, txt);
    return txt + ' FCFA';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------- 1. OBSERVATION */

  var D = lire();

  /* Découpage en visites. Le nombre de visites distingue un curieux de
     passage de quelqu'un qui revient pour la troisième fois : le second
     est beaucoup plus près d'acheter. */
  (function sessions() {
    var t = now();
    if (!D.sess.last || t - D.sess.last > SESSION_GAP) {
      D.sess.n = (D.sess.n || 0) + 1;
      D.sess.s = t;
    }
    D.sess.last = t;
  })();

  /* Provenance : d'où vient ce visiteur, maintenant et la première fois. */
  (function provenance() {
    try {
      var p = new URLSearchParams(location.search);
      var utm = p.get('utm_source') || p.get('utm_medium') || '';
      var camp = p.get('utm_campaign') || '';
      var ref = document.referrer || '';
      var hote = '';
      if (ref) { try { hote = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) {} }
      if (hote && hote === location.hostname) hote = '';
      if (!D.src.first) D.src.first = utm || hote || 'direct';
      if (utm || hote) D.src.last = utm || hote;
      if (camp) D.src.camp = camp;
      /* un visiteur arrivé par un lien promo est un visiteur au prix */
      if (/black|friday|promo|solde|deal|remise/i.test(camp + ' ' + location.pathname)) D.src.promo = now();
    } catch (e) {}
  })();

  /* Recherche interne : ce que quelqu'un tape est l'intention la plus
     explicite qu'il puisse donner. */
  (function recherche() {
    try {
      var p = new URLSearchParams(location.search);
      var q = p.get('q');
      if (q && q.length > 1) {
        D.q.unshift({ q: q.toLowerCase().slice(0, 60), t: now() });
        D.q = D.q.slice(0, 12);
      }
    } catch (e) {}
  })();

  /* Rayon parcouru. */
  (function rayon() {
    var m = location.pathname.match(/\/collections\/([^/?#]+)/);
    if (m && m[1] && m[1] !== 'all') bump(D.cols, m[1], 1.2);
  })();

  /* Fiche produit : vue, répétition, et temps réellement passé dessus. */
  var vueEnCours = null;
  (function fiche() {
    var pr = (window.MI && window.MI.product) || null;
    if (!pr || !pr.id) return;
    var id = String(pr.id);
    var v = D.views[id] || { n: 0, t: 0, dwell: 0 };
    v.n += 1;
    v.t = now();
    v.p = pr.price || v.p || 0;
    v.ty = pr.type || v.ty || '';
    v.vd = pr.vendor || v.vd || '';
    v.h = pr.handle || v.h || '';
    v.ti = pr.title || v.ti || '';
    v.co = pr.cols || v.co || [];
    D.views[id] = v;

    bump(D.types, v.ty, 1.5);
    bump(D.vendors, v.vd, 1);
    (v.co || []).forEach(function (c) { bump(D.cols, c, 0.8); });

    vueEnCours = { id: id, debut: now() };
  })();

  /* Le temps passé sépare le coup d'œil de l'examen sérieux. On le compte
     par tranches, plafonné à 5 minutes pour qu'un onglet oublié ne fausse
     pas tout. */
  function cloreVue() {
    if (!vueEnCours) return;
    var sec = Math.min(300, Math.round((now() - vueEnCours.debut) / 1000));
    vueEnCours.debut = now();
    if (sec < 2) return;
    var v = D.views[vueEnCours.id];
    if (!v) return;
    v.dwell = Math.min(3600, (v.dwell || 0) + sec);
    ecrire(D);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') cloreVue();
  });
  window.addEventListener('pagehide', cloreVue);

  /* Panier : le signal le plus fort avant la commande. */
  (function panier() {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-quick],[name="add"],.bt-add');
      if (!b) return;
      D.cart.n += 1;
      D.cart.t = now();
      var pr = (window.MI && window.MI.product) || null;
      if (pr && pr.id) {
        D.cart.ids = (D.cart.ids || []).filter(function (x) { return x !== String(pr.id); });
        D.cart.ids.unshift(String(pr.id));
        D.cart.ids = D.cart.ids.slice(0, 10);
      }
      ecrire(D);
    }, true);
  })();

  /* Élagage : on ne garde que les 150 vues les plus récentes. */
  (function elaguer() {
    var ids = Object.keys(D.views);
    if (ids.length <= MAX_VIEWS) return;
    ids.sort(function (a, b) { return (D.views[b].t || 0) - (D.views[a].t || 0); });
    ids.slice(MAX_VIEWS).forEach(function (id) { delete D.views[id]; });
  })();

  ecrire(D);

  /* ------------------------------------------------------- 2. INTENTION */

  /* Vues triées par force du signal : récence x répétition x temps passé. */
  function vuesClassees() {
    return Object.keys(D.views).map(function (id) {
      var v = D.views[id];
      var force = fraicheur(v.t) * (1 + Math.log(1 + (v.n || 1))) * (1 + Math.min(1.5, (v.dwell || 0) / 90));
      return { id: id, v: v, force: force };
    }).sort(function (a, b) { return b.force - a.force; });
  }

  /* Budget observé : médiane des prix regardés, pondérée par la force du
     signal. Quelqu'un qui n'a regardé que des produits à 35 000 ne doit
     pas voir une montre à 150 000 en tête de liste. */
  function budget(vues) {
    var px = [];
    vues.forEach(function (x) {
      if (x.v.p > 0) { var k = Math.max(1, Math.round(x.force * 3)); while (k--) px.push(x.v.p); }
    });
    if (px.length < 3) return null;
    px.sort(function (a, b) { return a - b; });
    return px[Math.floor(px.length / 2)];
  }

  /* L'intention décide de ce qu'on pousse. Elle n'est pas devinée au
     hasard : chaque cas correspond à un comportement observable. */
  function intention(vues) {
    var panierPlein = CFG.cartCount > 0;
    var revientSouvent = vues.length && vues[0].v.n >= 3;
    var achete = (CFG.bought || []).length > 0;

    if (panierPlein || revientSouvent) return 'achat';
    if (achete && D.sess.n > 1) return 'accessoire';

    /* comparaison : au moins trois fiches du même type dans la visite */
    var parType = {};
    vues.slice(0, 8).forEach(function (x) {
      if (x.v.t > D.sess.s) bump(parType, x.v.ty, 1);
    });
    for (var k in parType) { if (parType[k] >= 3) return 'comparaison'; }

    if (D.src.promo && now() - D.src.promo < 3 * DAY) return 'prix';
    if (!vues.length) return 'decouverte';
    return 'affinite';
  }

  /* ------------------------------------------------- 3. RECOMMANDATIONS */

  /* Shopify calcule ses propres recommandations à partir des commandes
     réelles de la boutique et du texte des fiches. C'est la seule source
     de « souvent acheté avec » qui repose sur de vraies ventes, et elle
     est gratuite. On la sollicite pour les trois produits les plus
     regardés, et pour le panier. */
  function recoShopify(ids, intent) {
    var urls = ids.slice(0, 3).map(function (id) {
      return root.replace(/\/$/, '') + '/recommendations/products.json?product_id=' +
        encodeURIComponent(id) + '&limit=8&intent=' + intent;
    });
    return Promise.all(urls.map(function (u) {
      return fetch(u, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (res) {
      var out = {};
      res.forEach(function (r, iSrc) {
        if (!r || !r.products) return;
        r.products.forEach(function (p, rang) {
          var id = String(p.id);
          /* le rang compte : le premier résultat vaut plus que le huitième,
             et le produit le plus regardé pèse plus que le troisième */
          var s = (1 / (1 + rang)) * (1 / (1 + iSrc));
          if (!out[id] || out[id].s < s) out[id] = { s: s, src: ids[iSrc], intent: intent };
        });
      });
      return out;
    });
  }

  /* ------------------------------------------------------- 4. NOTATION */

  function noter(cat, ctx) {
    var vues = ctx.vues, intent = ctx.intent, bud = ctx.bud;
    var aCols = ctx.aCols, aTypes = ctx.aTypes, aVend = ctx.aVend;
    var reco = ctx.reco, comp = ctx.comp;
    var dejaVu = ctx.dejaVu, achetes = ctx.achetes, auPanier = ctx.auPanier;

    var res = [];

    cat.forEach(function (p) {
      /* filtres durs : on ne recommande jamais ce qu'on ne peut pas vendre,
         ni ce qui est déjà dans le panier ou déjà acheté */
      if (!p.a) return;
      if (auPanier[String(p.i)]) return;
      if (achetes[String(p.i)]) return;

      var score = 0, raisons = [];

      /* a. recommandation Shopify, issue des commandes réelles */
      var r = reco[String(p.i)];
      if (r) {
        score += 100 * r.s;
        var sv = D.views[r.src];
        if (sv && sv.ti) raisons.push({ k: 'reco', w: 100 * r.s, t: 'Va avec ' + court(sv.ti, 20) });
      }
      var c = comp[String(p.i)];
      if (c) {
        score += 85 * c.s;
        var cv = D.views[c.src];
        raisons.push({ k: 'comp', w: 85 * c.s, t: cv && cv.ti ? 'Complète votre ' + court(cv.ti, 14) : 'Complète votre sélection' });
      }

      /* b. affinité : rayons, types et marques déjà parcourus */
      var aff = 0;
      (p.co || []).forEach(function (h) { if (aCols[h]) aff = Math.max(aff, aCols[h]); });
      if (p.ty && aTypes[p.ty]) aff = Math.max(aff, aTypes[p.ty] * 0.95);
      if (p.vd && aVend[p.vd]) aff = Math.max(aff, aVend[p.vd] * 0.6);
      if (aff > 0) {
        score += 60 * aff;
        if (aff > 0.45 && vues[0]) raisons.push({ k: 'aff', w: 60 * aff, t: 'Comme ce que vous regardez' });
      }

      /* c. recherche interne : correspondance avec les mots tapés */
      var mots = (D.q[0] && D.q[0].q || '').split(/\s+/).filter(function (m) { return m.length > 2; });
      if (mots.length) {
        var hay = (p.t + ' ' + (p.ty || '') + ' ' + (p.tg || []).join(' ')).toLowerCase();
        var hits = mots.filter(function (m) { return hay.indexOf(m) > -1; }).length;
        if (hits) {
          score += 50 * (hits / mots.length);
          raisons.push({ k: 'srch', w: 50 * (hits / mots.length), t: 'Correspond à votre recherche' });
        }
      }

      /* d. budget : cloche centrée sur le prix médian observé.
            L'écart est calculé en log, parce qu'entre 30 000 et 60 000 il y
            a le même fossé psychologique qu'entre 120 000 et 240 000. */
      if (bud && p.p > 0) {
        var d = Math.log(p.p / bud);
        var fit = Math.exp(-(d * d) / (2 * 0.45 * 0.45));
        score += 30 * fit;
        if (fit > 0.75 && raisons.length === 0) raisons.push({ k: 'bud', w: 30 * fit, t: 'Dans votre budget' });
      }

      /* e. intention */
      var estAcc = /accessoire|charg|cable|câble|batterie|ecouteur|écouteur|casque|bracelet|coque|protection/i
        .test((p.ty || '') + ' ' + (p.co || []).join(' ') + ' ' + p.t);
      if (intent === 'accessoire' || intent === 'achat') {
        if (estAcc) { score += 45; raisons.push({ k: 'acc', w: 45, t: 'Va avec votre achat' }); }
      } else if (intent === 'prix') {
        if (p.c > p.p) { score += 45; }
      } else if (intent === 'comparaison') {
        /* en comparaison on pousse le cran au-dessus plutôt que le même */
        if (bud && p.p > bud * 1.05 && p.p < bud * 1.9) {
          score += 40;
          raisons.push({ k: 'up', w: 40, t: 'Le cran au-dessus' });
        }
      } else if (intent === 'decouverte') {
        if (p.bs) score += 40;
      }

      /* f. urgence réelle, jamais inventée */
      if (p.q > 0 && p.q <= 5) {
        score += 25;
        raisons.push({ k: 'stock', w: 25, t: 'Plus que ' + p.q + ' en stock' });
      }

      /* g. nouveauté */
      if (p.nw) {
        score += 20;
        raisons.push({ k: 'new', w: 20, t: 'Nouveau' });
      }

      /* h. promotion réelle */
      if (p.c > p.p) {
        var pct = Math.round((p.c - p.p) * 100 / p.c);
        if (pct >= 5) {
          score += 18 + Math.min(22, pct);
          raisons.push({ k: 'promo', w: 18 + Math.min(22, pct), t: '−' + pct + '% en ce moment' });
        }
      }

      /* i. mise en avant décidée par la boutique */
      if (p.bo) score += 35;

      /* j. meilleure vente, utile quand on ne sait rien du visiteur */
      if (p.bs) {
        score += 15;
        raisons.push({ k: 'best', w: 15, t: 'Parmi les plus vendus' });
      }

      /* pénalité : déjà vu plusieurs fois. Lui remontrer ce qu'il a déjà
         ouvert quatre fois n'apporte rien, il connaît. */
      var dv = dejaVu[String(p.i)];
      if (dv) {
        if (dv.n >= 4) score -= 45;
        else if (dv.n >= 2) score -= 18;
        else score += 12; /* vu une fois et pas revenu : une piqûre de rappel */
      }

      if (score <= 0) return;

      /* la raison affichée est la plus forte, ajustée par ce qui marche
         sur ce visiteur précis (voir le bandit plus bas) */
      raisons.sort(function (a, b) { return (b.w * poidsRaison(b.k)) - (a.w * poidsRaison(a.k)); });
      res.push({ p: p, score: score, raison: raisons[0] || { k: 'best', t: '' } });
    });

    return res.sort(function (a, b) { return b.score - a.score; });
  }

  /* Petit bandit : on retient le taux de clic par type de raison pour CE
     visiteur, et on fait remonter les raisons qui marchent sur lui. Borné
     pour qu'une raison ne monopolise jamais la grille, avec une part
     d'exploration. */
  function poidsRaison(k) {
    var r = D.reasons[k];
    if (!r || r.i < 8) return 1;
    var ctr = r.c / r.i;
    var base = 1 + Math.max(-0.25, Math.min(0.4, (ctr - 0.06) * 4));
    if (Math.random() < 0.15) return 1; /* exploration */
    return base;
  }

  /* Diversité : sans garde-fou, le moteur affiche cinq téléphones de la
     même série. On plafonne par type et par marque. */
  function diversifier(liste, n) {
    var out = [], parType = {}, parVend = {};
    for (var i = 0; i < liste.length && out.length < n; i++) {
      var p = liste[i].p;
      var ty = p.ty || '-', vd = p.vd || '-';
      if ((parType[ty] || 0) >= 2) continue;
      if ((parVend[vd] || 0) >= 4) continue;
      parType[ty] = (parType[ty] || 0) + 1;
      parVend[vd] = (parVend[vd] || 0) + 1;
      out.push(liste[i]);
    }
    /* s'il manque des places, on complète sans contrainte */
    for (var j = 0; j < liste.length && out.length < n; j++) {
      if (out.indexOf(liste[j]) === -1) out.push(liste[j]);
    }
    return out;
  }

  /* --------------------------------------------------------- 5. AFFICHAGE */

  function carte(item, idx) {
    var p = item.p, s = CFG.card || {};
    var pct = (p.c > p.p && p.c > 0) ? Math.round((p.c - p.p) * 100 / p.c) : 0;
    var h = '';

    h += '<div class="pop-c" data-reco-card data-pid="' + esc(p.i) + '" data-reason="' + esc(item.raison.k) + '" data-rank="' + idx + '">';

    if (s.brand && s.brandImg) {
      h += '<span class="brand" aria-hidden="true"><img src="' + esc(s.brandImg) + '" alt="" width="60" height="60" loading="lazy"></span>';
    }
    if (pct >= 5) h += '<span class="tag">-' + pct + '%</span>';

    h += '<a class="ph" href="' + esc(p.u) + '" aria-label="' + esc(p.t) + '">';
    if (p.im) h += '<img src="' + esc(p.im) + '" alt="' + esc(p.t) + '" width="460" height="460" loading="lazy" decoding="async">';
    h += '</a>';

    h += '<a class="nm" href="' + esc(p.u) + '">' + esc(p.t) + '</a>';

    if (s.desc) h += '<div class="ds">' + esc(p.d || '') + '</div>';

    h += '<div class="pz">';
    if (p.mv) h += '<span class="from">à partir de</span>';
    h += '<span>' + money(p.p) + '</span>';
    if (pct >= 5) h += '<s>' + money(p.c) + '</s>';
    h += '</div>';

    /* La ligne de raison remplace la ligne « stock faible » du gabarit :
       même emplacement, même hauteur, donc aucune carte ne se décale. */
    h += '<div class="low reco-why">' + esc(item.raison.t || '') + '</div>';

    h += '<div class="btw">';
    if (p.mv) {
      h += '<a class="bt bt-ch" href="' + esc(p.u) + '">' + esc(s.choose || 'Choisir les options') + '</a>';
    } else {
      h += '<button type="button" class="bt bt-add" data-quick="' + esc(p.vid) + '">' + esc(s.add || 'Ajouter au panier') + '</button>';
    }
    h += '</div></div>';
    return h;
  }

  /* --------------------------------------------------------- 6. ORCHESTRE */

  function lancer() {
    var grille = document.querySelector('[data-reco-grid]');
    if (!grille) return;

    var cat = CFG.catalogue;
    if (!cat || !cat.length) return;

    var vues = vuesClassees();
    var intent = intention(vues);
    var bud = budget(vues);

    var dejaVu = {};
    vues.forEach(function (x) { dejaVu[x.id] = x.v; });

    var achetes = {};
    (CFG.bought || []).forEach(function (id) { achetes[String(id)] = 1; });
    var auPanier = {};
    (CFG.inCart || []).forEach(function (id) { auPanier[String(id)] = 1; });

    /* les produits qui servent de point de départ aux recommandations
       Shopify : panier d'abord, sinon les fiches les plus regardées */
    var graines = (CFG.inCart && CFG.inCart.length ? CFG.inCart.map(String) : [])
      .concat(vues.map(function (x) { return x.id; }))
      .filter(function (v, i, a) { return a.indexOf(v) === i; });

    var ctxBase = {
      vues: vues, intent: intent, bud: bud,
      aCols: normalise(D.cols), aTypes: normalise(D.types), aVend: normalise(D.vendors),
      dejaVu: dejaVu, achetes: achetes, auPanier: auPanier
    };

    function rendre(reco, comp) {
      ctxBase.reco = reco || {};
      ctxBase.comp = comp || {};
      var classe = noter(cat, ctxBase);
      if (!classe.length) return;

      var n = CFG.count || 8;
      var choix = diversifier(classe, n);

      grille.innerHTML = choix.map(carte).join('');
      grille.setAttribute('data-intent', intent);

      /* on compte une impression par raison affichée */
      choix.forEach(function (it) {
        var k = it.raison.k;
        D.reasons[k] = D.reasons[k] || { i: 0, c: 0 };
        D.reasons[k].i += 1;
      });
      ecrire(D);

      document.dispatchEvent(new CustomEvent('mi:reco', { detail: { intent: intent, n: choix.length } }));
    }

    /* Sans historique, inutile d'appeler Shopify : on note tout de suite
       sur les meilleures ventes et les nouveautés. */
    if (!graines.length) { rendre({}, {}); return; }

    var intentReco = (intent === 'achat' || intent === 'accessoire') ? 'complementary' : 'related';

    Promise.all([
      recoShopify(graines, intentReco),
      intentReco === 'related' ? recoShopify(graines, 'complementary') : Promise.resolve({})
    ]).then(function (r) {
      rendre(r[0], r[1]);
    }).catch(function () {
      rendre({}, {});
    });
  }

  /* clic sur une carte recommandée : on apprend */
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest && e.target.closest('[data-reco-card]');
    if (!c) return;
    var k = c.getAttribute('data-reason');
    if (k) {
      D.reasons[k] = D.reasons[k] || { i: 0, c: 0 };
      D.reasons[k].c += 1;
      ecrire(D);
    }
  }, true);

  /* La grille n'est calculée que lorsqu'elle approche de l'écran : sur la
     page d'accueil elle est sous la ligne de flottaison, rien ne sert de
     dépenser du réseau avant. */
  function armer() {
    var g = document.querySelector('[data-reco-grid]');
    if (!g) return;
    if (!('IntersectionObserver' in window)) { lancer(); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { io.disconnect(); lancer(); }
      });
    }, { rootMargin: '600px 0px' });
    io.observe(g);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armer);
  } else { armer(); }

  /* petite console pour vérifier ce que le moteur a compris :
     tapez MiReco.etat() dans la console du navigateur */
  window.MiReco = {
    etat: function () {
      var vues = vuesClassees();
      return {
        intention: intention(vues),
        budget: budget(vues),
        visites: D.sess.n,
        vues: vues.slice(0, 10).map(function (x) {
          return { produit: x.v.ti || x.v.h, fois: x.v.n, secondes: x.v.dwell, force: +x.force.toFixed(2) };
        }),
        rayons: normalise(D.cols),
        types: normalise(D.types),
        provenance: D.src,
        raisons: D.reasons
      };
    },
    oublier: function () { try { localStorage.removeItem(KEY); } catch (e) {} D = vide(); return 'historique effacé'; }
  };
})();
